/* eslint-disable @typescript-eslint/no-non-null-assertion */
import moment from 'moment';
import { CartProductSchema } from '../../../../types';
import { getFormattedDateString } from '@css-xp/base';
import { truthy } from '../../../../utils';
/*
  E1: Next bill date = 1 Oct
  Current bill cycle: 1 sept to 1 oct
  Next Eligible bill cycle: between 1 oct to 1 nov

  E2: Next bill date = 3 Oct
  Current bill cycle: 3 sept to 3 oct
  Next Eligible bill cycle:between 3 oct to 3 nov

  E3: Next bill date = 6 Oct
  Current bill cycle: 6 sept to 6 oct
  Next Eligible bill cycle: between 6 oct to 6 nov

  E4: Next bill date = 9 Oct
  Current bill cycle: 9 sept to 9 oct
  Next Eligible bill cycle: between 9 oct to 9 nov

  E5: Next bill date = 12 Oct
  Current bill cycle: 12 sept to 12 oct
  Next Eligible bill cycle: between 12 oct to 12 nov

  Say today is 22nd sept. and given all bills are prepaid,
  Overall allowed range for this set of entitlements = 12 oct to 1 nov
  Range >= biggest of eligible start date && <= smallest of eligible end date
 */
const calendarDateFormat = 'YYYY-MM-DD';

function getValidDateRange(nextBillCycles: { start: number; end: number }[]): { start: string; end: string } {
  const startTimestamps = nextBillCycles.map(({ start }) => start);
  const endTimestamps = nextBillCycles.map(({ end }) => end);

  const maxNextBillStartTimestamp = Math.max(...startTimestamps);
  const minNextBillEndTimestamp = Math.min(...endTimestamps);

  const formattedStartDate = getFormattedDateString({
    date: `${maxNextBillStartTimestamp}`,
    format: calendarDateFormat,
  });
  const formattedEndDate = getFormattedDateString({ date: `${minNextBillEndTimestamp}`, format: calendarDateFormat });

  return {
    start: formattedStartDate!,
    end: formattedEndDate!,
  };
}

export function getValidNextBillDateRange(products: CartProductSchema[]) {
  const nextBillDates = products.map(({ nextBillDate }) => nextBillDate).filter(truthy);
  const nextBillCycles = nextBillDates.map((nextBillDate) => {
    const endTimestamp = moment.utc(Number(nextBillDate)).add(1, 'months').valueOf();

    return {
      start: Number(nextBillDate),
      end: endTimestamp,
    };
  });

  const validDateRange = getValidDateRange(nextBillCycles);

  return validDateRange;
}
